import { render, staticRenderFns } from "./MainNavTab.vue?vue&type=template&id=71d4ae24&scoped=true"
import script from "./MainNavTab.vue?vue&type=script&lang=js"
export * from "./MainNavTab.vue?vue&type=script&lang=js"
import style0 from "./MainNavTab.vue?vue&type=style&index=0&id=71d4ae24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d4ae24",
  null
  
)

export default component.exports